import * as tslib_1 from "tslib";
export function extractTitleConfig(titleConfig) {
  var anchor = titleConfig.anchor,
      frame = titleConfig.frame,
      offset = titleConfig.offset,
      orient = titleConfig.orient,
      color = titleConfig.color,
      titleMarkConfig = tslib_1.__rest(titleConfig, ["anchor", "frame", "offset", "orient", "color"]);

  var mark = Object.assign({}, titleMarkConfig, color ? {
    fill: color
  } : {});
  var nonMark = Object.assign({}, anchor ? {
    anchor: anchor
  } : {}, offset ? {
    offset: offset
  } : {}, orient ? {
    orient: orient
  } : {});
  return {
    mark: mark,
    nonMark: nonMark
  };
}